import React from 'react';
// @ts-ignore
import styles from './SearchCaseContactNoResults.module.scss';
import useTranslation from '../../Hooks/useTranslation';

interface Props {}

const SearchCaseContactNoResults: React.FC<Props> = () => {
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<div className={styles.text}>
				{t('component.searchCaseContactNoResults.text')}
			</div>
		</div>
	);
};

export default SearchCaseContactNoResults;
